import DocumentReview from '@/pages/DocumentReviewPage';
import { Buffer } from 'buffer/';
import { QAIssueButtons, QualityCheckOptions } from './QAIssueButtons';
import { RecordFormData } from '../DocumentReviewPage/RecordForm';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { DOC_REF_QUERY } from '@/graphql/queries/record-management';
import { DocumentMetaTag, PatchOperation } from '@/types/recordManagement';
import { FH_UI_CODESYSTEM } from '@/constants';
import { Coding } from '@/gql/graphql';
import { fhirAPI } from '@/lib/axios';
import { toast } from '@/components/hooks/use-toast';

export default function QAIssue() {
  const documentId = '2c9ba460-57f1-4dba-a135-14bee875f66b'; /* hardcoded */
  const questionnaireResponseId =
    'a513a2ea-56b1-4b29-ac31-3e389547f19b'; /* hardcoded */
  const [recordFormData, setrecordFormData] = useState<RecordFormData | null>(
    null
  );
  const { data } = useQuery<{
    DocumentReference: { meta: { tag: DocumentMetaTag[] } };
  }>(DOC_REF_QUERY, {
    variables: { id: documentId },
  });

  const getValue = (type: QualityCheckOptions): Coding => {
    switch (type) {
      case 'passed': {
        return {
          system: FH_UI_CODESYSTEM,
          code: 'mr-qa-audit-passed',
          display: 'QA Audit Passed',
        };
      }
      case 'failed': {
        return {
          system: FH_UI_CODESYSTEM,
          code: 'mr-qa-audit-failed',
          display: 'QA Audit Failed',
        };
      }
    }
  };

  const getDocumentReference = (type: QualityCheckOptions) => {
    const tags = data?.DocumentReference?.meta?.tag;
    let value: Coding;
    let op: PatchOperation;
    let removeOpValue: Coding;
    if (type === 'passed') {
      value = getValue(type);
      removeOpValue = getValue('failed');
    } else {
      value = getValue(type);
      removeOpValue = getValue('passed');
    }
    if (!tags) {
      op = {
        op: 'add',
        path: '/meta/tag',
        value: [value],
      };
    }
    const existingTagIndex = tags?.findIndex((tag) => tag.code === value.code);
    const existingRemoveTagIndex = tags?.findIndex(
      (tag) => tag.code === removeOpValue.code
    );

    op = {
      op: existingTagIndex === -1 ? 'add' : 'replace',
      path:
        existingTagIndex === -1
          ? '/meta/tag/-'
          : `/meta/tag/${existingTagIndex}`,
      value,
    };
    const opertations: PatchOperation[] = [
      {
        op: 'replace',
        path: '/date',
        value: new Date().toISOString(),
      },
      {
        op: 'replace',
        path: '/status',
        value: value.code as string,
      },
    ];

    if (existingRemoveTagIndex !== -1) {
      opertations.push({
        op: 'remove',
        path: `/meta/tag/${existingRemoveTagIndex}`,
      });
    }
    opertations.push(op);

    return Buffer.from(JSON.stringify(opertations), 'utf8').toString('base64');
  };

  const prepareDocumentUpdateData = (type: QualityCheckOptions) => {
    const documentReference = getDocumentReference(type);
    const data = {
      resourceType: 'Bundle',
      type: 'transaction',
      entry: [
        {
          resource: {
            resourceType: 'QuestionnaireResponse',
            status: 'active',
            item: [
              {
                linkId: 'medical-record-patient-name-listed-on-record',
                text: 'Name as listed on record',
                answer: [
                  {
                    id: 'patient-name',
                    valueString: recordFormData?.nameOnRecord,
                  },
                ],
              },
              {
                linkId: 'medical-record-type-of-record',
                text: 'Type of record',
                answer: [
                  {
                    valueCoding: {
                      code: recordFormData?.typeOfRecord?.value,
                      display: recordFormData?.typeOfRecord?.label,
                      system:
                        'https://fluentinhealth.com/FHIR/CodeSystem/FluentHealthUI',
                    },
                  },
                ],
              },
              {
                linkId: 'medical-record-title-of-record',
                text: 'Title of record',
                answer: [
                  {
                    id: 'document-title',
                    valueString: recordFormData?.title,
                  },
                ],
              },
              {
                linkId: 'medical-record-date-of-record',
                text: 'Date of record',
                answer: [
                  {
                    id: 'date',
                    valueDate: recordFormData?.recordDate
                      ? new Date(recordFormData?.recordDate).toLocaleString(
                          'en-CA',
                          {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                          }
                        )
                      : '',
                  },
                ],
              },
              {
                linkId: 'medical-record-doctor-name',
                text: 'Doctor',
                answer: [
                  {
                    valueString: recordFormData?.doctorName,
                  },
                ],
              },
            ],
            id: questionnaireResponseId,
          },
          request: {
            method: 'PUT',
            url: `QuestionnaireResponse/${questionnaireResponseId}`,
          },
        },
        {
          resource: {
            resourceType: 'Binary',
            contentType: 'application/json-patch+json',
            data: documentReference,
          },
          request: {
            method: 'PATCH',
            url: `DocumentReference/${documentId}`,
          },
        },
      ],
    };
    return data;
  };

  const handleQualityCheckBtnClick = (type: QualityCheckOptions) => {
    console.log('updateDocumentData', 'updateDocumentData');

    let updateDocumentData;
    if (type === 'passed') {
      updateDocumentData = prepareDocumentUpdateData(type);
    } else {
      updateDocumentData = prepareDocumentUpdateData(type);
    }
    fhirAPI
      .post('', updateDocumentData)
      .then(() => {
        toast({
          title: 'Success',
          description: 'Document updated successfully',
          variant: 'default',
        });
      })
      .catch(() => {
        toast({
          title: 'Error',
          description: 'Document update failed',
          variant: 'destructive',
        });
      });
  };
  return (
    <div
      className="overflow-y-scroll p-8 h-full relative"
      style={{ background: '#fff' }}
    >
      <DocumentReview
        showHeader={false}
        customButtons={
          <QAIssueButtons onQABtnClick={handleQualityCheckBtnClick} />
        }
        setRecordFormData={setrecordFormData}
      />
    </div>
  );
}
